export default {
  accountTags: undefined,
  accountTagsLoading: false
}
